import { render, staticRenderFns } from "./PModal.vue?vue&type=template&id=f3990d0a&scoped=true"
import script from "./PModal.vue?vue&type=script&lang=ts"
export * from "./PModal.vue?vue&type=script&lang=ts"
import style0 from "./PModal.vue?vue&type=style&index=0&id=f3990d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3990d0a",
  null
  
)

export default component.exports